import React, { useState } from 'react';
import { NavBar } from '../kuroco/AppBars';
import { useNavigateWithFilters } from '../../utils/dashboardNav';
import InquiryForm from './InquiryForm';
import InquiryList from './InquiryList';

const HELP_FAQS = [
  {
    q: 'POS連携がうまくいきません',
    a: 'POSデータは通常、翌日に反映されます。24時間以上反映されない場合は、店舗管理者にお問い合わせください。',
  },
  {
    q: 'データはどのくらいで反映されますか？',
    a: 'POSデータは前日までの実績が、通常は翌朝にダッシュボードに反映されます。',
  },
  {
    q: '目標や行動プランは後から変更できますか？',
    a: 'はい。設定画面の「目標設定」から、AIマネージャーと相談しながらいつでも変更できます。',
  },
  {
    q: '毎日のリマインド通知が届きません',
    a: 'PWAをホーム画面に追加し、ブラウザの通知を許可してください。設定画面で通知時間も確認できます。',
  },
  {
    q: 'AIマネージャーにはどう相談すればいいですか？',
    a: '「AI相談」タブから、現状分析・行動記録・改善策相談のメニューを選んで相談できます。',
  },
  {
    q: 'グラフの金色の点線は何ですか？',
    a: '「目標達成に必要」な動きです。売上と注力指標の目標を達成するとき、その指標がこの先どう動く必要があるかを表しています。',
  },
];

/**
 * ヘルプ・お問い合わせ: よくある質問 → お問い合わせの入力 → これまでのお問い合わせ（自分の分）。
 * 送れたら完了画面（番号つき）。そこから、そのやり取り（チャット）を開ける。
 */
export default function HelpScreen() {
  const navigate = useNavigateWithFilters();
  const [open, setOpen] = useState(null);
  const [done, setDone] = useState(null);
  const openThread = (id) => navigate(`/settings/help/inquiries/${id}`);

  if (done) {
    return (
      <div className="app">
        <NavBar title="ヘルプ・お問い合わせ" backLabel="設定" backTo="/settings" hideSettings />
        <div className="scroll fade" style={{ paddingTop: 56 }}>
          <div className="onb-done-head">
            <div className="onb-done-ic">✓</div>
            <div className="onb-done-t">送信が完了しました</div>
            <div className="onb-done-s">
              お問い合わせありがとうございます。
              {done.numberLabel && (
                <>
                  <br />
                  お問い合わせ番号：<b>{done.numberLabel}</b>
                </>
              )}
              <br />
              内容を確認のうえ、担当よりご連絡いたします。
            </div>
          </div>
          {done.id && (
            <button type="button" className="onb-cta onb-cta--full onb-cta--ghost" onClick={() => openThread(done.id)}>
              このお問い合わせを見る
            </button>
          )}
          <button type="button" className="onb-cta onb-cta--full" onClick={() => navigate('/settings')}>
            設定に戻る
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <NavBar title="ヘルプ・お問い合わせ" backLabel="設定" backTo="/settings" hideSettings />
      <div className="scroll fade" style={{ padding: '16px 20px 32px' }}>
        <div className="help-sec-head">
          <span className="help-sec-ic">💡</span>
          <span className="help-sec-t">よくある質問</span>
        </div>
        <div className="faq">
          {HELP_FAQS.map((f, i) => (
            <div className={`faq-item${open === i ? ' is-open' : ''}`} key={f.q}>
              <button type="button" className="faq-q" onClick={() => setOpen(open === i ? null : i)}>
                {f.q}
                <span className="faq-chev">{open === i ? '−' : '+'}</span>
              </button>
              {open === i && <div className="faq-a">{f.a}</div>}
            </div>
          ))}
        </div>

        <div className="help-sec-head" style={{ marginTop: 28 }}>
          <span className="help-sec-ic">✉️</span>
          <span className="help-sec-t">お問い合わせ</span>
        </div>
        <InquiryForm onSent={setDone} />

        <div className="help-sec-head" style={{ marginTop: 28 }}>
          <span className="help-sec-ic">💬</span>
          <span className="help-sec-t">これまでのお問い合わせ</span>
        </div>
        <InquiryList onOpen={openThread} />
      </div>
    </div>
  );
}
